import { render, staticRenderFns } from "./PrinterBinMappingForm.vue?vue&type=template&id=1dd7d674&scoped=true&"
import script from "./PrinterBinMappingForm.vue?vue&type=script&lang=js&"
export * from "./PrinterBinMappingForm.vue?vue&type=script&lang=js&"
import style0 from "./PrinterBinMappingForm.vue?vue&type=style&index=0&id=1dd7d674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7d674",
  null
  
)

export default component.exports